import { Card, CardContent } from '@/components/ui/card';

interface GameStatsProps {
  gamesPlayed: number;
  gamesWon: number;
  currentStreak: number;
  maxStreak: number;
  winRate: number;
}

export function GameStats({ gamesPlayed, currentStreak, maxStreak, winRate }: GameStatsProps) {
  const stats = [
    { label: 'Played', value: gamesPlayed },
    { label: 'Win %', value: Math.round(winRate * 100) },
    { label: 'Current Streak', value: currentStreak },
    { label: 'Max Streak', value: maxStreak },
  ];

  return (
    <Card data-testid="game-stats">
      <CardContent className="pt-6">
        <div className="flex justify-around text-center">
          {stats.map((stat) => (
            <div key={stat.label}>
              <div className="text-3xl font-bold">{stat.value}</div>
              <div className="text-xs text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
